(function($) {

$(function() {
    $(document).on('click', '.js-create-doc-dir', function(e) {
        var dialog = document.querySelector('#docs-new-dialog');
        if (dialog) dialog.close();

        var $btn = $(this);
        var $listEl = $('.doc-list');
        var $dirEl = $listEl.find('.doc-dir-item.new');

        if ($dirEl.length < 1) {
            $dirEl = $($('#tpl-create-doc-dir').html()).prependTo($listEl);
            $dirEl.attr({
                'data-url': $btn.data('url'),
                'data-parent-guid': $btn.data('doc-dir-guid')
            });
        }

        $('.init-docs').hide();
        $('.docs-view').show();
        $dirEl.find('.txt-doc-dir-name').focus().select();
    }).on('click', '.doc-dir-item.new .link-submit-doc-dir', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var $dirEl = $link.closest('.doc-dir-item.new');
        var $docList = $dirEl.closest('.doc-list');

        if ($dirEl.hasClass('loading')) {
            return;
        }

        var $txtName = $dirEl.find('.txt-doc-dir-name');
        var name = $txtName.val();

        if (!name) {
            $txtName.addClass('error');
            return;
        } else {
            $txtName.removeClass('error');
        }

        $dirEl.addClass('loading');
        $txtName.prop('disabled', true);
        $.ajax({
            url: $dirEl.data('url'),
            data: {
                name: name,
                parent_doc_dir_guid: $dirEl.data('parent-guid')
            },
            success: function(result) {
                var $newDirEl = $(result.html);
                $dirEl.replaceWith($newDirEl);

                if ($('#page-project').length) {
                    $newDirEl.find('a[data-stack-replace]').removeAttr('data-stack-replace');
                    $docList.find( ".doc-or-dir:gt(5)" ).remove();
                }

                tower.adjustReadableTime($newDirEl);
                tower.initPermission($newDirEl);

                $docList.trigger('docdircreate', [$newDirEl]);
            }
        });
    }).on('click', '.doc-dir-item.new .link-cancel-doc-dir', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var $dirEl = $link.closest('.doc-dir-item.new');
        if ($dirEl.hasClass('loading')) {
            return;
        }

        $link.closest('.doc-dir-item.new').fadeOut(function() {
            $(this).remove();
        });
    }).on('keydown', '.doc-dir-item.new .txt-doc-dir-name', function(e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('.doc-dir-item').find('.link-cancel-doc-dir').trigger('click');
        } else if (e.which == 13) {
            e.preventDefault();
            $(this).closest('.doc-dir-item').find('.link-submit-doc-dir').trigger('click');
        }
    }).on( "ajax:success", ".doc-dir-item .link-delete", function( e ) {
        var dirEl = $( this ).closest( ".doc-dir-item" );
        dirEl.fadeOut( function() {
            dirEl.remove();
            tower.refreshSelectedDocs();
        });
    });

    // select docs in file list
    $(document).on('click', '.docs-view.list-view .doc-or-dir', function(e) {
        if (!tower.me.admin) {
            return;
        }

        var $target = $(e.target);
        if ($target.is('.link') || $target.parent().is('.link')) {
            return;
        }

        e.preventDefault();
        var $item = $(this);
        var $view = $item.closest('.docs-view');
        var baseSelected = $view.data('base-selected');

        if (e.shiftKey) {
            var lastSelected = baseSelected[baseSelected.length - 1];
            if (baseSelected.length < 1) {
                $item.addClass('selected');
                baseSelected.push($item[0]);
            } else if (lastSelected === $item[0]) {
                $item.parent('.doc-list').children().removeClass('selected');
                $(baseSelected).addClass('selected');
            } else {
                var $items = $item.parent('.doc-list').children().removeClass('selected');
                if ($items.index($item) > $items.index(lastSelected)) {
                    $item.prevUntil(lastSelected)
                        .addBack()
                        .addClass('selected');
                } else {
                    $item.nextUntil(lastSelected)
                        .addBack()
                        .addClass('selected');
                }

                $(baseSelected).addClass('selected');
            }
        } else if (tower.metaKey(e)) {
            if ($item.hasClass('selected')) {
                $item.removeClass('selected');

                var index = $.inArray($item[0], baseSelected);
                if (index > -1) {
                    baseSelected.splice(index, 1);
                }
            } else {
                $item.addClass('selected');
                baseSelected.push($item[0]);
            }
        } else {
            $item.addClass('selected')
                .siblings('.doc-or-dir')
                .removeClass('selected');
            baseSelected.length = 0;
            baseSelected.push($item[0]);
        }

        tower.refreshSelectedDocs();

    }).on('click', '.docs-view .doc-selected-info .link-cancel-select', function(e) {
        e.preventDefault();

        var $view = $('.docs-view');
        var baseSelected = $view.data('base-selected');
        $view.find('.doc-or-dir').removeClass('selected');
        tower.refreshSelectedDocs();

        baseSelected.length = 0;
    });

    $(document).on('click', '.link-doc-dir-move, .doc-selected-info .link-move-doc-dir', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var $dialog = $(simple.tpl($('#tpl-doc-dir-dialog').html()));
        var $dirs = $dialog.find('.doc-dirs');
        var $submit = $dialog.find('button[type=submit]');
        var dirGuids = [$link.data('doc-dir-guid')];
        var projectGuid = $link.data('project-guid');

        var items = $link.data('items');
        if (items) {
            dirGuids = items.documentdirs;
        }

        var tree = renderTree($dialog, projectGuid, dirGuids);
        var select = initSelectProj($dialog, tree);

        tree.on('nodeselected', function(e, $node, item) {
            $dialog.find('.target-doc-dir-guid').val(item.guid);
            $dialog.find('.tpuid').val();
            $submit.prop('disabled', false);
        });

        var dialog = simple.dialog({
            content: $dialog,
            width: 450,
            modal: true,
            buttons: null
        });

        $dialog.find('.form-change').attr('action', $link.data('move-url'));
        $dialog.find('.form-change .name').text($link.data('name'));


        $dialog.find('.btn-cancel-move').on('click', function(e) {
            dialog.remove();
        });

        if (items) {
            $dialog.find('.form-change').on('ajax:beforeSend', function(e, xhr, settings) {
                var documents = $.map(items.documents, function(guid, i) {
                    return {
                        document: guid
                    };
                });
                var shimoDocuments = $.map(items.shimo_documents, function(guid, i) {
                    return {
                        shimo_documents: guid
                    };
                });
                var tencentDocuments = $.map(items.tencent_documents, function(guid, i) {
                    return {
                        tencent_documents: guid
                    };
                });
                var documentdirs = $.map(items.documentdirs, function(guid, i) {
                    return {
                        documentdir: guid
                    };
                });
                var resources = $.merge($.merge($.merge(documents, shimoDocuments), tencentDocuments), documentdirs);
                settings.data += "&resources=" + JSON.stringify(resources);
            });
        }

        $dialog.find('.form-change').on('ajax:success', function(e, result) {
            var targetDirGuid = $dialog.find('.target-doc-dir-guid').val();
            var needRemove = !($('#page-documentdirs').length > 0 && $('#page-documentdirs').data('doc-dir-guid') === targetDirGuid);
            if ($('#tencent_docs-documents-show').length) {
                location.href = result.dir_url;
            } else if ($link.parent().is('.doc-selected-info')) {
                var $view = $link.closest('.docs-view');
                if (needRemove) {
                    $view.find('.doc-list .doc-or-dir.selected').remove();
                } else {
                    $view.find('.doc-list .doc-or-dir.selected').removeClass('selected');
                }

                tower.refreshSelectedDocs();

                var baseSelected = $view.data('base-selected');
                baseSelected.length = 0;
            } else if (needRemove) {
                $link.closest('.doc-or-dir').fadeOut(function() {
                    $(this).remove();
                });
            }

            dialog.remove();
        });

        $dirs.on('mousewheel', function(e, delta) {
            $(this).scrollTop($(this).scrollTop() - 30 * delta);
            return false;
        });
    });

    function initSelectProj($dialog, tree) {
        var $select = $dialog.find('.choose-projects');

        var select = simple.select({
            el: $select,
            placeholder: '点击选择项目',
            cls: 'select-choose-projects'
        });

        $.ajax({
            url: "/members/" + tower.me.guid + "/projects.json/",
            type: 'get',
            dataType: 'json',
            success: function(result) {
                var projGuid = $select.data('project');
                var items = [];
                var selectedItem = null;
                $.each(result, function(i, proj) {
                    var item;
                    item = {
                        label: proj.name,
                        guid: proj.guid,
                        key: proj.name + " " + proj.name_pinyin + " " + proj.name_pinyin_abbr
                    };
                    if (projGuid === item.guid) {
                        selectedItem = item;
                    }
                    items.push(item);
                });
                $select.removeClass('loading');
                select.setItems(items);
                select.selectItem($.inArray(selectedItem, items));

                select.on('select', function(e, item) {
                    var showRoot = '';
                    if (projGuid !== item.guid || $('#page-project, #page-docs').length < 1) {
                        showRoot = '?show_root_dir=true';
                    }

                    $dialog.find('button[type=submit]').prop('disabled', true);
                    $dialog.find('.tpuid').val(item.guid);
                    tree.refresh({
                        url: '/projects/' + item.guid + '/doc_dirs' + showRoot
                    });
                });
            }
        });



        return select;
    }

    function renderTree($dialog, projectGuid, dirGuids) {
        var showRoot = $('#page-project, #page-docs').length < 1 ? '?show_root_dir=true' : '';
        var tree = simple.tree({
            el: $dialog.find('.doc-dirs'),
            url: '/projects/' + projectGuid + '/doc_dirs' + showRoot,
            placeholder: '没有创建过文档夹',
            nodeProperties: {
                id: 'guid',
                params: {
                    parent_doc_dir_guid: 'guid'
                }
            },
            onNodeRender: function($node, item) {
                if ($.inArray(item.guid, dirGuids) > -1) {
                    $node.remove();
                } else {
                    $node.find('.toggle').after('<i class="icon-folder twr twr-todo-desc"/>');
                }
            }
        });
        return tree;
    }
});

$.extend( window.tower, {
    initDocDnD: function(listEl) {
        var $listEl = listEl ? $(listEl) : $('.doc-list');

        if (tower.me.admin) {
            makeDraggable($listEl.find('.doc-or-dir'));
            makeDroppable($listEl.find('.doc-dir-item'));
            makeDroppable($('.crumb').find('.link-doc-dir'));
        }

        $listEl.on('docdircreate', function(e, $dirEl) {
            makeDraggable($dirEl);
            makeDroppable($dirEl);
        });

        function makeDraggable($dragEl) {
            $dragEl.draggable({
                scope: 'move-doc',
                cancel: '.docs-view.list-view *',
                zIndex: 100,
                cursorAt: {
                    top: -5,
                    left: -5
                },
                helper: function() {
                    var $el = $(this);
                    var $helper = $('<div class="drag-helper">\
                            <i class="twr twr-ban"></i>\
                            <i class="twr twr-check"></i>\
                        </div>');
                    if ($el.hasClass('doc-item')) {
                        return $helper.addClass('doc-drag-helper');
                    } else if ($el.hasClass('doc-dir-item')) {
                        return $helper.addClass('doc-dir-drag-helper');
                    } else {
                        return $el;
                    }
                },
                start: function(e, ui) {
                    var $el = $(this);
                    if ($el.hasClass('loading')) {
                        return false;
                    }

                    $el.addClass('dragging');
                    $listEl.addClass('dragging');
                    $el.on('click.dnd', function(e) {
                        return false;
                    })
                },
                stop: function(e, ui) {
                    var $el = $(this).removeClass('dragging');
                    $listEl.removeClass('dragging');
                    setTimeout(function() {
                        $el.off('click.dnd');
                    }, 100);
                }
            });
        }

        function makeDroppable($dropEl) {
            $dropEl.droppable({
                scope: 'move-doc',
                cancel: '.docs-view.list-view *',
                activeClass: 'droppable',
                hoverClass: 'dropover',
                tolerance: 'pointer',
                over: function(e, ui) {
                    ui.helper.addClass('dragover');
                },
                out: function(e, ui) {
                    ui.helper.removeClass('dragover');
                },
                drop: function(e, ui) {
                    var $dir = $(this);
                    moveDocOrDir(ui.draggable, $dir);
                }
            });
        }

        function moveDocOrDir($srcEl, $targetEl) {
            $srcEl.addClass('loading');

            $.ajax({
                url: $srcEl.find('.link-doc-dir-move').data('move-url'),
                data: {
                    target_doc_dir_guid: $targetEl.data('guid')
                },
                type: "post"
            }).done(function(result) {
                $srcEl.fadeOut(function() {
                    var $docListEl = $srcEl.parents('.docs-list');
                    var $docsViewEl = $docListEl.parents('.docs-view');
                    $srcEl.remove();
                    if ($docListEl.children().length <= 0) {
                        $docsViewEl.hide();
                        $docsViewEl.before('<div class="init init-doc">\
                                                <div class="title"><span class="twr twr-todo-desc"></span>文档夹已经搬空了</div>\
                                            </div>');
                    }
                });
            });

            var $desc = $targetEl.find('.doc-dir-desc');
            var count = $targetEl.find('.doc-dir-desc').text().trim().match(/\d+/) || 0;
            count = (typeof count == 'object') ? (+count[0] + 1) : 1;
            if ($srcEl.hasClass('doc-dir-item')) {
                $desc.text('共 ' + count + ' 个文档');
            }
        }
    },

    refreshSelectedDocs: function() {
        var $selected = $('.docs-view .doc-or-dir.selected');
        var selectedCount = $selected.length;
        if ( selectedCount > 0) {
            var items = {
                documents: [],
                shimo_documents: [],
                tencent_documents: [],
                documentdirs: []
            };

            $selected.each(function(i, el) {
                $el = $(el);
                if ($el.is('.doc-item-shimo')) {
                    items.shimo_documents.push($el.data('g uid'));
                } else if ($el.is('.doc-item-tencent')) {
                    items.tencent_documents.push($el.data('guid'));
                } else if ($el.is('.doc-item')) {
                    items.documents.push($el.data('guid'));
                } else {
                    items.documentdirs.push($el.data('guid'));
                }
            });

            $('.doc-selected-info').show()
                .find('.doc-selected-count em')
                .text(selectedCount)
                .end()
                .find('.link-move-doc-dir')
                .data('name', selectedCount + '项')
                .data('items', items);

        } else {
            $('.doc-selected-info').hide()
                .find('.doc-selected-count em')
                .text('0')
                .end()
                .find('.link-move-doc-dir')
                .removeData('name')
                .removeData('items');
        }
    }
});

})(jQuery);
